import React, { useState, useRef, useEffect } from "react";
import "./AgendaControls.css";
import { LuPlus, LuChevronDown, LuCalendarDays, LuLayoutGrid, LuCheck } from "react-icons/lu";
import {
  AGENDA_CATEGORY_LIST,
  EXPLORE_CATEGORY_LIST,
} from "../../constants/agendaConstants";

export default function AgendaControls({
  viewMode,
  setViewMode,
  selectedCategory,
  setSelectedCategory,
  onCreateClick,
}) {
  const [filterOpen, setFilterOpen] = useState(false);
  const filterRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (filterRef.current && !filterRef.current.contains(e.target)) {
        setFilterOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const categoriesList =
    viewMode === "explore" ? EXPLORE_CATEGORY_LIST : AGENDA_CATEGORY_LIST;

  const currentLabel =
    categoriesList.find((c) => c.id === selectedCategory)?.filterLabel || "All Types";

  const handleTabChange = (mode) => {
    setViewMode(mode);
  };

  return (
    <div className="agenda-controls-bar">
      {/* Left controls: Explore / Schedules Tab Switcher */}
      <div className="agenda-controls-left">
        <div className="agenda-view-switcher">
          <button
            className={`agenda-view-tab-btn ${viewMode === "explore" ? "active" : ""}`}
            onClick={() => handleTabChange("explore")}
          >
            <LuLayoutGrid size={15} />
            <span>Explore</span>
          </button>
          <button
            className={`agenda-view-tab-btn ${viewMode === "schedules" ? "active" : ""}`}
            onClick={() => handleTabChange("schedules")}
          >
            <LuCalendarDays size={15} />
            <span>Schedules</span>
          </button>
        </div>
      </div>

      {/* Right controls: Types Dropdown Filter + Create Event Button */}
      <div className="agenda-controls-right">
        {/* Types Filter Dropdown */}
        <div className="agenda-filter-dropdown-wrapper" ref={filterRef}>
          <button
            className="agenda-filter-btn"
            onClick={() => setFilterOpen((prev) => !prev)}
            aria-expanded={filterOpen}
          >
            <span>{currentLabel}</span>
            <LuChevronDown size={15} />
          </button>

          {filterOpen && (
            <div className="agenda-filter-menu">
              {categoriesList.map((cat) => (
                <div
                  key={cat.id}
                  className={`agenda-filter-item ${selectedCategory === cat.id ? "selected" : ""}`}
                  onClick={() => {
                    setSelectedCategory(cat.id);
                    setFilterOpen(false);
                  }}
                >
                  <span>{cat.filterLabel || cat.label}</span>
                  {selectedCategory === cat.id && <LuCheck size={14} color="#00BADA" />}
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Create Event Button */}
        <button className="agenda-create-btn" onClick={onCreateClick}>
          <LuPlus size={16} />
          <span>Create Event</span>
        </button>
      </div>
    </div>
  );
}
